// Global compose bus — openCompose() from anywhere (a lead page, a selected
// row, an inbox reply) and ComposeDock (mounted once in the Shell) pops the
// Gmail-style window bottom-right. Same shape as lib/toast.js: no state
// library, no prop threading, and the dock survives navigation.
const listeners = new Set()
let counter = 0

// Height the dock currently occupies, published as a CSS variable so the toast
// stack can float above it instead of covering the Send button.
export function setComposeDockHeight(px) {
  try {
    document.documentElement.style.setProperty('--compose-dock-h', `${px}px`)
  } catch {
    /* no document */
  }
}

// draft: { to?, cc?, subject?, body?, company?, city?, trade?, contactName?,
//          threadId?, inReplyTo?, mode?: 'new' | 'reply' }
export function openCompose(draft = {}) {
  const msg = { id: `c${++counter}`, mode: 'new', ...draft }
  listeners.forEach((fn) => fn(msg))
  return msg.id
}

export function onCompose(fn) {
  listeners.add(fn)
  return () => listeners.delete(fn)
}

// "Re: subject" without stacking prefixes on a long reply chain.
export function replySubject(subject) {
  const s = (subject || '').trim()
  if (!s) return 'Re:'
  return /^re:/i.test(s) ? s : `Re: ${s}`
}

// Gmail shows the address only; strip the display name from "Name <a@b.com>".
export function bareAddress(from) {
  const m = /<([^>]+)>/.exec(from || '')
  return (m ? m[1] : from || '').trim()
}
